import { render } from "./PuntoCyan.vue?vue&type=template&id=9d74285e&scoped=true"
import script from "./PuntoCyan.vue?vue&type=script&lang=ts"
export * from "./PuntoCyan.vue?vue&type=script&lang=ts"

import "./PuntoCyan.vue?vue&type=style&index=0&id=9d74285e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d74285e"

export default script